import React, { useEffect } from 'react';

const ShopPage = () => {
  useEffect(() => {
    // Redirect to the external Shop site
    window.location.href = 'https://shop.stemlabs.edu.lk/';
  }, []);

  return (
    <div className="container py-16 flex flex-col items-center justify-center min-h-[60vh]">
      <h1 className="text-3xl font-bold mb-6">Redirecting to Shop...</h1>
      <p>You are being redirected to the STEM Labs Online Shop.</p>
      <p>If you are not redirected automatically, please click <a href="https://shop.stemlabs.edu.lk/" className="text-theme-accent hover:underline">here</a>.</p>
    </div>
  );
};

export default ShopPage; 